export default __webpack_public_path__ + "static/25-baa6959a41687acf1a8d1b48c2684743.jpg";